<template>
  <section class="places container defaultSectionPaddings">
    <div v-for="item in data.items" class="places__Item">
      <Flare :srcset="item.place.image" size="both" width="644" height="492" crop="fill" :alt="item.place.image" />

      <div class="places__ItemTexts">
        <h2 v-text="item.place.title" />
        <p v-text="item.place.description" />
        <div class="places__BottomInfos">
          <div class="places__Region">
            <i18n-t tag="p" scope="global" keypath="region">
              <template #region>
                {{ item.place.region }}
              </template>
            </i18n-t>
          </div>
          <div class="places__Properties">
            <p>{{ $t('property', item.place.accommodation_count) }}</p>
          </div>
        </div>
      </div>
      
      <nuxt-link :to="item.place.sef">{{ item.place.title }}</nuxt-link>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_places.scss');
</style>